module.exports = __webpack_public_path__ + "static/media/Лесная День.70b5a1b3.jpg";